(function(){
    angular
        .module('appback')
        .directive('ngValidarstockpedido', validarStockPedido);
        validarStockPedido.$inject = ['PedidosService','$timeout', 'Upload', '$uibModal'];
        function validarStockPedido(PedidosService,$timeout, Upload, $uibModal){
            return {
              templateUrl: '/backend/pedidos/template?name=validarstockpedido.twig',
		        scope: {
                    pc:'=',
                },
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
                        scope.stocksPorMaterial = {};

                        scope.init = function(){
                            function loadStock(){
                                PedidosService.checkStockPendiente(scope.pc.pedidoActivoID,function(stocksPedido){
                                    if(stocksPedido.stock_pendiente_insertar){
                                        $timeout(loadStock, 5000);  
                                    }else{
                                        scope.pc.pedidoActivo.stocks = stocksPedido.stocks;
                                        scope.pc.pedidoActivo.stock_pendiente_insertar = false;
                                        scope.pc.pedidoActivo.validacion_completada = stocksPedido.validacion_completada;
                                        scope.initStocks();
                                    }
                                });
                            }
                            loadStock();
                        }

                        scope.initStocks = function(){
                            scope.stocksPorMaterial = {};
                            console.log("init validacion", scope.pc.pedidoActivo);
                            angular.forEach(scope.pc.pedidoActivo.stocks, function(stock) {
                                if (!scope.stocksPorMaterial[stock.material.id]) {
                                    scope.stocksPorMaterial[stock.material.id] = {
                                        material: stock.material,
                                        stocks: []
                                    };
                                }
                                scope.stocksPorMaterial[stock.material.id].stocks.push(stock);
                            });
                            console.log("stocksPorMaterial", scope.stocksPorMaterial);
                        }
                        scope.init();

                        scope.popupValidacion = false;
                        scope.openModalValidacion = function(stock){
                            console.log("abrir modal validacion", stock);
                            scope.popupValidacion = $uibModal.open({
                                animation: true,
                                ariaLabelledBy: 'modal-title-top',
                                ariaDescribedBy: 'modal-body-top',
                                //windowClass: 'modal-danger',
                                //backdrop  : 'static',
                                templateUrl: 'validacionpopup.html',
                                size: 'lg',
                                controller: function($scope) {
                                    $scope.stock = stock;
                                    $scope.validado = false;
                                    $scope.validacionesMaterial = [];
                                    $scope.validacionesHechas = [];

                                    $scope.camaraEstado = {};
                                    $scope.grabando = false;
                                    $scope.mediaRecorder = null;
                                    $scope.audioRecording = false;

                                    PedidosService.getValidacionesStock(stock.material_id, stock.id, function(data){
                                        console.log("validaciones material", data);
                                        $scope.validacionesMaterial = data.validaciones_material.sort(function(a, b) {
                                            if (!a.categoria || !b.categoria) return 0;
                                            return a.categoria.nombre.localeCompare(b.categoria.nombre);
                                        });
                                        $scope.validacionesHechas = data.validaciones_hechas;
                                        $scope.user_role = data.user_role;
                                        $scope.validado = data.validado;
                                    });

                                    $scope.getIndexValidaciones = function(id_validacionmaterial,_key) {
                                        for (let index = 0; index < $scope.validacionesHechas?.length; index++) {
                                            if ($scope.validacionesHechas[index]["id_validacionmaterial"] == id_validacionmaterial){
                                                return index;
                                            }
                                            
                                        }
                                        return _key;
                                    }

                                    $scope.abrirCamara = function(tipo, index) {
                                        if ($scope.camaraEstado[index]) {
                                            console.log("La cámara ya está abierta");
                                            return;
                                        }

                                        $scope.camaraEstado[index] = true;
                                        var video = document.getElementById('video-' + index);

                                        // Intentar abrir la cámara trasera primero
                                        var constraints = {
                                            video: { facingMode: { exact: "environment" } },
                                            audio: tipo === 'Video'
                                        };

                                        navigator.mediaDevices.getUserMedia(constraints)
                                            .then(function(stream) {
                                                $scope.streamActual = stream;
                                                video.srcObject = stream;
                                                video.style.display = 'block';
                                                video.play();
                                            })
                                            .catch(function(err) {
                                                console.warn("No se pudo abrir la cámara trasera, intentando la frontal...", err);

                                                // Fallback: abrir cámara frontal si la trasera no está disponible
                                                var fallbackConstraints = {
                                                    video: { facingMode: "user" },
                                                    audio: tipo === 'Video'
                                                };

                                                navigator.mediaDevices.getUserMedia(fallbackConstraints)
                                                    .then(function(stream) {
                                                        $scope.streamActual = stream;
                                                        video.srcObject = stream;
                                                        video.style.display = 'block';
                                                        video.play();
                                                    })
                                                    .catch(function(err2) {
                                                        $scope.camaraEstado[index] = false;
                                                        $scope.cerrarCamara(index);
                                                        console.error("No se pudo acceder a ninguna cámara:", err2);
                                                    });
                                            });
                                    };

                                    $scope.cerrarCamara = function(index) {
                                        if($scope.streamActual) {
                                            var video = document.getElementById('video-' + index);
                                            $scope.streamActual.getTracks().forEach(track => track.stop());
                                            video.srcObject = null;
                                            video.style.display = 'none';
                                            $scope.camaraEstado[index] = false;
                                            $scope.grabando = false;
                                        }
                                    };

                                    $scope.capturarImagen = function(index) {
                                        var video = document.getElementById('video-' + index);
                                        var canvas = document.getElementById('canvas-' + index);
                                        canvas.width = video.videoWidth;
                                        canvas.height = video.videoHeight;
                                        canvas.getContext('2d').drawImage(video, 0, 0);
                                        var imageData = canvas.toDataURL('image/png');
                                        $scope.subirArchivo(dataURItoBlob(imageData), 'imagen.png', index);
                                        $scope.cerrarCamara(index);
                                    };

                                    $scope.iniciarGrabacion = function(index) {
                                        if ($scope.streamActual) {
                                            $scope.grabando = true;
                                            var chunks = [];
                                            $scope.mediaRecorder = new MediaRecorder($scope.streamActual);
                                            $scope.mediaRecorder.ondataavailable = function(e) {
                                                chunks.push(e.data);
                                            };
                                            $scope.mediaRecorder.onstop = function() {
                                                var blob = new Blob(chunks, { type: 'video/mp4' });
                                                $scope.subirArchivo(blob, 'video.mp4', index);
                                            };
                                            $scope.mediaRecorder.start();
                                        }
                                    };

                                    $scope.detenerGrabacion = function(index) {
                                        if ($scope.mediaRecorder && $scope.grabando) {
                                            $scope.mediaRecorder.stop();
                                            $scope.grabando = false;
                                            $scope.cerrarCamara(index);
                                        }
                                    };

                                    $scope.grabarAudio = function(index) {
                                        console.log("navigator", navigator.mediaDevices);
                                        $scope.audioRecording = true;
                                        navigator.mediaDevices.getUserMedia({ audio: true })
                                        .then(function(stream) {
                                            $scope.mediaRecorder = new MediaRecorder(stream);
                                            var chunks = [];
                                    
                                            $scope.mediaRecorder.start();
                                            console.log("Grabación de audio iniciada");
                                    
                                            $scope.mediaRecorder.ondataavailable = function(e) {
                                                chunks.push(e.data);
                                            };
                                    
                                            $scope.mediaRecorder.onstop = function(e) {
                                                console.log("Grabación de audio detenida");
                                                var blob = new Blob(chunks, { 'type' : 'audio/mp3' });
                                                chunks = [];
                                                var audioURL = URL.createObjectURL(blob);
                                                $scope.subirArchivo(audioURL, 'audio.mp3', index);
                                                stream.getTracks().forEach(track => track.stop());
                                            };
                                    
                                            /*$timeout(function() {
                                                mediaRecorder.stop();
                                            }, 5000);*/
                                        })
                                        .catch(function(err) {
                                            console.log("An error occurred while recording audio: " + err);
                                        });
                                    };
              
                                    $scope.detenerAudio = function(index) {
                                      if($scope.audioRecording && $scope.mediaRecorder){
                                          $scope.mediaRecorder.stop();
                                          $scope.audioRecording = false;  
                                      }
                                    }

                                    $scope.subirArchivo = function(fileDataBlob, fileName, index) {
                                        var file = new File([fileDataBlob], fileName);
                                        $scope.uploadFiles([file], index);
                                    };

                                    $scope.borrarFichero = function(index,index_validacion){
                                        $scope.validacionesHechas[index_validacion].files.splice(index,1)
                                    }

                                    function dataURItoBlob(dataURI) {
                                        var byteString = atob(dataURI.split(',')[1]);
                                        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
                                        var ab = new ArrayBuffer(byteString.length);
                                        var ia = new Uint8Array(ab);
                                        for (var i = 0; i < byteString.length; i++) {
                                            ia[i] = byteString.charCodeAt(i);
                                        }
                                        return new Blob([ab], {type: mimeString});
                                    }

                                    $scope.uploadFiles = function (files, index_validacion) {
                                        if (files && files.length) {
                                          for (var i = 0; i < files.length; i++) {
                                            console.log("Fichero a subir", files[i]);
                                            Upload.upload({
                                                  url: '/backend/pedidos/subirficherovalidacion',
                                                  data: { file: files[i] }
                                              }).then(function (resp) {
                                                  if (resp.data.code > 0) {
                                                    if (!angular.isDefined($scope.validacionesHechas[index_validacion]?.files)) {
                                                        $scope.validacionesHechas[index_validacion].files = [];
                                                    }
                                                    $scope.validacionesHechas[index_validacion].files.push(resp.data);
                                                      
                                                  }
                                                  
                                              }, function (resp) {
                                              }, function (evt) {
                                                  var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                                              });
                                          }
                                          
                                        }
                                    }

                                    $scope.guardarValidacion = function(){
                                        if(!angular.isDefined($scope.stock.unidades_validacion) || $scope.stock.unidades_validacion == "null" || $scope.stock.unidades_validacion == null){
                                            $scope.stock.unidades_validacion = 0;
                                        }
                                        console.log("guardando validacion", $scope.validacionesHechas);
                                        console.log("unidades_validcion", $scope.stock.unidades_validacion);
                                        PedidosService.guardarValidacion($scope.stock.id, $scope.stock.unidades_validacion, $scope.validacionesHechas, function(data){
                                            console.log("data return guardar validacion", data);
                                            $scope.koForm();
                                        });
                                    }

                                    $scope.finalizarValidacion = function(){
                                        if(!angular.isDefined($scope.stock.unidades_validacion) || $scope.stock.unidades_validacion == "null" || $scope.stock.unidades_validacion == null){
                                            $scope.stock.unidades_validacion = 0;
                                        }
                                        console.log("finalizando validacion", $scope.validacionesHechas);
                                        console.log("unidades_validcion", $scope.stock.unidades_validacion);
                                        PedidosService.guardarValidacion($scope.stock.id, $scope.stock.unidades_validacion, $scope.validacionesHechas, function(data){
                                            PedidosService.finalizarValidacion($scope.stock.id, $scope.stock.pedido_id, function(data){
                                                console.log("data return finalizar validacion", data);
                                                if(data.code>0){
                                                    scope.pc.pedidoActivo = data.pedido.pedido;
                                                    scope.init();
                                                }
                                                $scope.koForm();
                                            });
                                        });
                                    }
                                    
                                    $scope.okForm = function(){
                                        scope.popupValidacion.close();
                                    }
                                    $scope.koForm = function(){
                                        scope.popupValidacion.close();
                                    }
                                }
                            });
                        }

                        scope.popupLiberacion = false;
                        scope.openModalLiberacion = function(stock){
                            console.log("abrir modal liberacion", stock);
                            scope.popupLiberacion = $uibModal.open({
                                animation: true,
                                ariaLabelledBy: 'modal-title-top',
                                ariaDescribedBy: 'modal-body-top',
                                //windowClass: 'modal-danger',
                                //backdrop  : 'static',
                                templateUrl: 'liberacionpopup.html',
                                size: 'lg',
                                controller: function($scope) {
                                    $scope.stock = stock;
                                    $scope.liberado = stock.liberado;
                                    $scope.form = {
                                        cantidad_liberar: 0,
                                        almacen_id: stock.almacen_id
                                    };

                                    $scope.puedoLiberar = function(almacen_required){
                                        if(almacen_required && !$scope.form.almacen_id){
                                            return false;
                                        }
                                        
                                        var cantidad_a_liberar = parseFloat($scope.form.cantidad_liberar) || 0;
                                        var cantidad_en_stock = parseFloat($scope.stock.cantidad) || 0;
                                        

                                        if(cantidad_a_liberar <= 0){
                                            return false;
                                        }
                                        return cantidad_a_liberar <= cantidad_en_stock;
                                    }
                                    
                                    $scope.liberarStock = function(cantidad_liberar, almacen_id){
                                        PedidosService.liberarStock($scope.stock.id, $scope.stock.pedido_id, cantidad_liberar, almacen_id, function(data){
                                            console.log("data liberarstock",data);
                                            if(data.code > 0){
                                                scope.pc.pedidoActivo = data.pedido.pedido;
                                                scope.init();
                                                $scope.koForm();
                                            }
                                        })
                                    }

                                    $scope.liberarTodoStock = function(almacen_id){
                                        console.log("liberando todo el stock al almacen", almacen_id, $scope.stock.cantidad);
                                        $scope.liberarStock($scope.stock.cantidad, almacen_id);
                                    }

                                    $scope.rechazarStock = function(cantidad_liberar){
                                        PedidosService.rechazarStock($scope.stock.id, $scope.stock.pedido_id, cantidad_liberar, function(data){
                                            console.log("data rechazarStockMaterial",data);
                                            if(data.code > 0){
                                                scope.pc.pedidoActivo = data.pedido.pedido;
                                                scope.init();
                                                $scope.koForm();
                                            }
                                        });
                                    }

                                    $scope.rechazarTodoStock = function(){
                                        console.log("rechazando todo el stock");
                                        $scope.rechazarStock($scope.stock.cantidad);
                                    }
                                    
                                    $scope.okForm = function(){
                                        scope.popupLiberacion.close();
                                    }
                                    $scope.koForm = function(){
                                        scope.popupLiberacion.close();
                                    }
                                }
                            });
                        }

                        scope.popupCoa = false;
                        scope.openModalCoa = function(stock){
                            console.log("abrir modal COA", stock);
                            scope.popupCoa = $uibModal.open({
                                animation: true,
                                ariaLabelledBy: 'modal-title-top',
                                ariaDescribedBy: 'modal-body-top',
                                //windowClass: 'modal-danger',
                                //backdrop  : 'static',
                                templateUrl: 'coapopup.html',
                                size: 'lg',
                                controller: function($scope) {
                                    $scope.stock = stock;
                                    
                                    $scope.okForm = function(){
                                        scope.popupCoa.close();
                                        scope.init();
                                    }
                                    $scope.koForm = function(){
                                        scope.popupCoa.close();
                                        scope.init();
                                    }
                                }
                            });
                        }
			        });
		        }
          }
      }
})();